import React from 'react';
import ReactDOM from "react-dom/client";
import store from "./store";
import { Provider } from 'react-redux';
import App from './App';
import ProdRedirection from './components/ProdRedirection/ProdRedirection';
import './index.css';
// import { datadogRum } from '@datadog/browser-rum';
// import { trace } from '@opentelemetry/api';
// import './services/otel/instrumentation';
// import { InitOtel } from './services/otel/init';

// InitOtel({
//     env: process.env.REACT_APP_ENV || "development",
//     version: `${process.env.REACT_APP_ENV}:${process.env.REACT_APP_COMMIT_VERSION || 'unknown'}`,
//     name: 'tv-terminal'
// })
// import TraceProvider from './services/otel/instrumentation';
// const tracer = trace.getTracer('tv-terminal', process.env.REACT_APP_ENV);

// var span = tracer.startSpan('app-load');
// datadogRum.init({
//     applicationId: '778a52c3-6713-42f0-af19-0fe4e86b9129',
//     clientToken: 'pub4225b131f419017e6a89a7b27ea26696',
//     site: 'datadoghq.eu',
//     service: 'tv-terminal',
//     env: process.env.REACT_APP_ENV,
//     // Specify a version number to identify the deployed version of your application in Datadog
//     version: process.env.REACT_APP_ENV+":"+process.env.REACT_APP_COMMIT_VERSION, 
//     sessionSampleRate: 100,
//     sessionReplaySampleRate: 0,
//     trackUserInteractions: true,
//     trackResources: true,
	
//     trackLongTasks: true,
//     defaultPrivacyLevel: 'mask-user-input',
// 	beforeSend: (event, context) => {
//         // collect a RUM resource's response headers
//         if (event.type === 'resource' && event.resource.type === 'fetch' && context?.requestInput?.origin == "https://vortex-api.rupeezy.in") {
//             event.context.responseHeaders = Object.fromEntries(context.response.headers)
			
//         }
//         return true
//     },
// });


  

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<>
        {/* <TraceProvider> */}
            <Provider store={store}>
                {["staging", "pre_prod"].includes(process.env.REACT_APP_ENV) ? <ProdRedirection /> : <div></div>}
                <App />
            </Provider>
        {/* </TraceProvider> */}
	</>
);
// ReactDOM.render(
// 	<React.StrictMode>
// 		<Provider store={store}>
// 			<App />
// 		</Provider>
// 	</React.StrictMode>,
// 	document.getElementById('root')
// );
